import moment from "moment";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import SocioCard from "../../DesignSystem/SocioCard";
import SearchIcon from "@mui/icons-material/Search";
import FlatIconButton from "../../DesignSystem/FlatButton";
import DatePicker from "../../DesignSystem/DatePicker";
import { GetListReviews, GetListReviewsByDate } from "../Infrastructure/Business.presenter";
import ModalAlert from "../../DesignSystem/ModalAlert";

const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: 24,
  },
  socioList: {
    display: "grid",
    placeItems: "center",
    gap: 35,
    width: "100%",
    height: "auto",
    paddingLeft: 24,
    paddingRight: 24,
    [theme.breakpoints.down("md")]: {
      paddingTop: 10,
      paddingBottom: 30,
      gridTemplateColumns: "1fr",
    },
    [theme.breakpoints.up("md")]: {
      paddingTop: 30,
      paddingBottom: 50,
      gridTemplateColumns: "1fr 1fr",
    },
    [theme.breakpoints.up("lg")]: {
      paddingTop: 20,
      paddingBottom: 30,
      gridTemplateColumns: "1fr 1fr",
    },
  },
}));

export default function SocioComercialList() {
  const { id } = useParams();
  const classes = useStyles();
  const [commentsRender, setCommentsRender] = useState(false);
  const [comments, setComments] = useState({});
  const [datePress, setDatePress] = useState(new Date());

  const [isOpenAlert, setOpenAlert] = useState(false);
  const [titleAlert, setTitleAlert] = useState("Ha ocurrido un error");
  const showAlertModal = () => setOpenAlert(true);

  const handleClickOpen = (alertState) => {
    setOpenAlert(alertState);
  };


  useEffect(() => {
    if (id) {
      fetchDataComments(id);
    }
  }, [id]);

  async function fetchDataComments(id) {
    try {
      const info = await GetListReviews(id);
      setComments(info);
      if (info.length !== 0) {
        setCommentsRender(true);
      }
    } catch (error) {
      console.log("Ha ocurrido un error, no hay comentarios.");
    }
  }

  const getSortDate = (value) => {
    setDatePress(moment(value).utc().format("YYYY-MM-DD"));
  };

  async function fetchCommentsToDate(){
    try {
      const info = await GetListReviewsByDate(id, datePress);
      if (info.length !== 0) {
        setComments(info);
        setCommentsRender(true);
      }else{
        setTitleAlert("Sin resultados en esta fecha");
        showAlertModal();
      }
    }catch(error){
      console.log("Ha ocurrido un error: ", error);
    }
  }

  return (
    <div style={{ width: "100%", minHeight: "100vh", paddingLeft: "80px", paddingTop: "20px" }}>
      <div className={classes.header}>
       {/*  <DatePicker title={"Fecha"} widthDate={"190px"} handleDate={getSortDate} /> */}
        <div style={{ marginTop: 20 }}>
          <FlatIconButton
            title={"Buscar"}
            icon={<SearchIcon fontSize="small" />}
            widthBtn={"180px"}
            onClick={fetchCommentsToDate}
          />
        </div>
      </div>

      <div className={classes.socioList}>
        {commentsRender ? (
          comments.map((value, index) => (
            <SocioCard
              id={index}
              key={index}
              userName={value.evaluator_id.name}
              lastName={value.evaluator_id.last_name}
              date={moment(new Date(value.createdAt)).format("DD/MM/YYYY")}
              stars={value.note}
              description={value.comment}
              typeUser={value.evaluator_id.role}
              avatar={value.evaluator_id.url_photoProfile}
            />
          ))
        ) : (
          <>
            {" "}
            <p style={{ minHeight: "200px", marginTop: "20px" }}>Sin comentarios aún</p>{" "}
          </>
        )}
      </div>
      <ModalAlert
        title={titleAlert}
        typeAlert={"error"}
        isOpen={isOpenAlert}
        handleAlert={handleClickOpen}
      />
    </div>
  );
}
